import { Tabs } from "../../../components/ui/Tabs";

import { ConectaPro } from "./conecta-pro";
import { Reminder } from "./reminder";
import { SellerApp } from "./seller-app";
import { Checklist } from "./checklist";

export function Services() {
  return (
    <Tabs.Root name="configuration-active-services-tabs" tabs={[
      "Conecta Pro",
      "App do Vendedor",
      // "Lembrete",
      "Checklist"]}>
      <Tabs.Content tabName="Conecta Pro" style={{ height: "100%" }}>
        <ConectaPro />
      </Tabs.Content>
      {/* <Tabs.Content tabName="Lembrete" style={{ height: "100%" }}>
        <Reminder />
      </Tabs.Content>*/}
      <Tabs.Content tabName="App do Vendedor" style={{ height: "100%" }}>
        <SellerApp />
      </Tabs.Content>
      <Tabs.Content tabName="Checklist" style={{ height: "100%" }}>
        <Checklist />
      </Tabs.Content>
    </Tabs.Root>
  )
}
